import api from "./api";
// @ts-expect-error - api is not typed
const groups = api.getPrefixedMethods("groups");
export const groupsService = {
    list: () => groups.get(""),
    create: (name, color) => groups.post("", { name, color }),
    update: (id, changes) => groups.patch(`${id}`, changes),
    /** Deactivates the group; its past assignments and notifications stay readable. */
    remove: (id) => groups.delete(`${id}`),
    /** Set semantics - the list replaces the membership wholesale. */
    setMembers: (id, userIds) => groups.put(`${id}/members`, { userIds }),
};
